import { useState, useEffect, useRef } from 'react';
import { getUsers, User } from 'api/todo/todoApi';
import useNotificationProvider from 'hooks/notificationBar/useNotificationProvider';

interface UseUsersReturn {
  users: User[];
  loading: boolean;
}

export const useUsers = (): UseUsersReturn => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const mountedRef = useRef(true);
  const { notifyWarning } = useNotificationProvider();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const data = await getUsers();
        if (mountedRef.current) {
          setUsers(data);
        }
      } catch (error) {
        console.error('[useUsers] Failed to fetch users:', error);
        notifyWarning('Could not load user list for assignments');
      } finally {
        if (mountedRef.current) {
          setLoading(false);
        }
      }
    };

    fetchUsers();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return { users, loading };
};
